import {Component} from '@angular/core';
import {DialogRef} from "@progress/kendo-angular-dialog";

@Component({
  selector: 'app-kendo-yes-no-dialog',
  templateUrl: './kendo-yes-no-dialog.component.html',
  styleUrls: ['./kendo-yes-no-dialog.component.scss']
})
export class KendoYesNoDialogComponent {
  title: string;
  question: string;

  constructor(private dialogRef: DialogRef) {
  }

  closeDialog(yesNo: string) {
    this.dialogRef.close(yesNo == 'Yes');
  }
}
